
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";

import FormWrapper from "@/components/form/FormWrapper.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import UIButton from "@/components/button/ui-button.vue";
import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselectNew.vue";
import IndustriesMultiselect from "@/components/autocompleteMultiselects/IndustriesMultiselectNew.vue";
import LanguagesMultiselect from "@/components/autocompleteMultiselects/LanguagesMultiselectNew.vue";
import CurrencySelect from "@/components/autocompleteMultiselects/CurrencySelect.vue";
import RateUnitSelect from "@/components/autocompleteMultiselects/RateUnitSelect.vue";
import InputRangeFilter from "@/components/filters/InputRangeFilter.vue";
import {
  Industry,
  Language,
  User_Industry,
  User_Language,
  User_Skill,
  User,
  User_Profile_By_Management,
  User_Experience,
  User_Education,
  User_Certification,
} from "@/generated/graphql";
import ProfileWebsite from "@/components/profile/ProfileWebsite.vue";
import ProfileDemoReel from "@/components/profile/ProfileDemoReel.vue";
import ProfileExperience from "@/components/profile/experiences/ProfileExperience.vue";
import ProfileEducation from "@/components/profile/educations/ProfileEducation.vue";
import ProfileCertification from "@/components/profile/certifications/ProfileCertification.vue";
import EducationForm from "@/components/profile/educations/EducationFormNew.vue";
import CertificationForm from "@/components/profile/certifications/CertificationForm.vue";
import ExperienceForm from "@/components/profile/experiences/ExperienceFormNew.vue";
import AddWorkSamplesToContractor from "@/components/contractors/AddWorkSamplesToContractorByManagement.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelectNew.vue";
import RegionInput from "@/components/autocompleteMultiselects/RegionInputCustom.vue";
import getStateValidationRules from "@/helpers/locations/stateValidationRules";
import DropdownOption from "@/entities/DropdownOption";
import MaskedPhoneInput from "@/components/common/MaskedPhoneInput.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import GET_SKILLS_BY_MANAGEMENT from "@/apollo/profile/profileDetails/management/GetSkillsByManagement.gql";
import UPSER_SKILLS_BY_MANAGEMENT from "@/apollo/profile/profileDetails/management/UpsertSkillsByManagement.gql";
import GET_INDUSTRIES_BY_MANAGEMENT from "@/apollo/profile/profileDetails/management/GetIndustriesByManagement.gql";
import UPSER_INDUSTRIES_BY_MANAGEMENT from "@/apollo/profile/profileDetails/management/UpsertIndustriesByManagement.gql";
import GET_LANGUAGES_BY_MANAGEMENT from "@/apollo/profile/profileDetails/management/GetLanguagesByManagement.gql";
import UPSER_DEMOREELS_BY_MANAGEMENT from "@/apollo/profile/profileDetails/management/UpsertDemoReelsByManagement.gql";
import REMOVE_DEMOREELS_BY_MANAGEMENT from "@/apollo/profile/profileDetails/management/RemoveDemoReelsByManagement.gql";
import UPSER_LANGUAGES_BY_MANAGEMENT from "@/apollo/profile/profileDetails/management/UpsertLanguagesByManagement.gql";
import UPSERT_PROFILE_BY_MANAGEMENT from "@/apollo/profile/profileDetails/management/UpsertProfileDetailsByManagement.gql";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import DeleteGray from "@/components/icons/DeleteGray.vue";
import countries from "@/data/locations/countries";
import States from "@/entities/locationEntities/States";
import Provinces from "@/entities/locationEntities/Provinces";
import isAllStatesOfPrimaryCountry from "@/helpers/locations/stateOfPrimaryCountry";
import getCountryRelatedValue from "@/helpers/locations/getCountryRelatedValue";
import ExperienceCard from "@/components/profile/experiences/ExperienceCard.vue";
import EducationCard from "@/components/profile/educations/EducationCard.vue";
import CertificationCard from "@/components/profile/certifications/CertifcationCard.vue";
import MailTo from "@/components/common/MailTo.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import UserResume from "@/entities/UserResume";

interface ManagementAddedInfoMode {
  skills: boolean;
  industries: boolean;
  languages: boolean;
  demoReel: boolean;
  workSamples: boolean;
  experience: boolean;
  education: boolean;
  certification: boolean;
  rating: boolean;
  contactInfo: boolean;
  website: boolean;
  company: boolean;
  jobTitle: boolean;
  rate: boolean;
  country: boolean;
  region: boolean;
  city: boolean;
  resume: boolean;
}
interface Observer extends Vue {
  reset: Function;
}
@Component({
  components: {
    ModalContent,
    ModalFullScreen,
    FormWrapper,
    SkillsMultiselect,
    IndustriesMultiselect,
    LanguagesMultiselect,
    CurrencySelect,
    RateUnitSelect,
    FormTextarea,
    FormGroup,
    UIButton,
    CrossIcon,
    InputRangeFilter,
    ProfileWebsite,
    ProfileDemoReel,
    ProfileExperience,
    CrossIconHover,
    ProfileEducation,
    ProfileCertification,
    EducationForm,
    CertificationForm,
    ExperienceForm,
    AddWorkSamplesToContractor,
    ProfileCountrySelect,
    DeleteGray,
    RegionInput,
    MaskedPhoneInput,
    ExperienceCard,
    EducationCard,
    CertificationCard,
    LoadingOverlay,
    MailTo,
  },
})
export default class ManagementAddContractorInfo extends Vue {
  @Prop({ type: Object, required: false })
  readonly managementAddedInfoMode?: ManagementAddedInfoMode;
  @Prop({ type: String, required: true }) readonly userId!: string;
  @Prop({ type: Object, required: true })
  readonly profileByManagement!: User_Profile_By_Management;
  @Prop({ type: Array, required: true })
  readonly experiencesByManagement!: User_Experience[];
  @Prop({ type: Array, required: true })
  readonly educationsByManagement!: User_Education[];

  closeModal(): void {
    this.$emit("closeInfo");
  }
  isHovered: boolean = false;
  skillsIds: number[] = [];
  industries: Industry[] = [];
  languages: Language[] = [];
  showEducationForm: boolean = false;
  showCertificationForm: boolean = false;
  showExperienceForm: boolean = false;
  showWorkSamplesForm: boolean = false;
  currentUser: User = Vue.prototype.$currentUser;
  country: DropdownOption[] = [];
  countryFromDB: string = this.profileByManagement
    ? this.profileByManagement.country
    : "";
  state: DropdownOption[] = [];
  processing: boolean = false;
  loading: boolean = false;
  phoneTouched: boolean = false;
  skills: User_Skill[] = [];
  // profileByManagementSet: User_Profile_By_Management = (({ __typename, ...others }) => others)(this.profileByManagement);
  emailHasErrors: boolean = false;
  phoneHasErrors: boolean = false;
  countryHasErrors: boolean = false;
  cityHasErrors: boolean = false;
  // user_id: string = this.profileByManagement ? this.profileByManagement.user_id : '';
  // added_by_id: string = this.profileByManagement ? this.profileByManagement.added_by_id : '';
  email: string = this.profileByManagement
    ? this.profileByManagement.email
    : "";
  phone: number = this.profileByManagement
    ? this.profileByManagement.phone
    : undefined;
  about: string = this.profileByManagement
    ? this.profileByManagement.about
    : "";
  city: string = this.profileByManagement ? this.profileByManagement.city : "";
  company_name: string = this.profileByManagement
    ? this.profileByManagement.company_name
    : "";
  created_at: string = this.profileByManagement
    ? this.profileByManagement.created_at
    : "";
  currency: string = this.profileByManagement
    ? this.profileByManagement.currency
    : "CAD";
  demo_reel: string = this.profileByManagement
    ? this.profileByManagement.demo_reel
    : "";
  profileDemoReel: string = this.profileByManagement
    ? this.profileByManagement.demo_reel
    : "";
  job_title: string = this.profileByManagement
    ? this.profileByManagement.job_title
    : "";
  max_rate: number = this.profileByManagement
    ? this.profileByManagement.max_rate
    : null;
  min_rate: number = this.profileByManagement
    ? this.profileByManagement.min_rate
    : null;
  occupation: string = this.profileByManagement
    ? this.profileByManagement.occupation
    : "";
  postal_code: string = this.profileByManagement
    ? this.profileByManagement.postal_code
    : "";
  rate_unit: string = this.profileByManagement
    ? this.profileByManagement.rate_unit
    : "hour";
  resume = this.profileByManagement ? this.profileByManagement.resume : null;
  summary: string = this.profileByManagement
    ? this.profileByManagement.summary
    : "";
  updated_at: string = this.profileByManagement
    ? this.profileByManagement.updated_at
    : "";
  website: string = this.profileByManagement
    ? this.profileByManagement.website
    : "";
  work_samples: string[] = this.profileByManagement
    ? this.profileByManagement.work_samples
    : [];
  year_of_experience: number = this.profileByManagement
    ? this.profileByManagement.year_of_experience
    : undefined;

  created(): void {
    if (this.managementAddedInfoMode.skills) {
      this.getSkills();
    }
    if (this.managementAddedInfoMode.industries) {
      this.getIndustries();
    }
    if (this.managementAddedInfoMode.languages) {
      this.getLanguages();
    }

    if (this.profileByManagement.country) {
      this.country = countries.filter(({ name }) => {
        const countryName = name.toLowerCase();
        const searchValue = this.profileByManagement.country.toLowerCase();
        return countryName.includes(searchValue);
      });
    }

    if (this.primaryCountry) {
      this.state = getCountryRelatedValue<DropdownOption[]>({
        countries: this.country,
        primary: [],
        onlyUSA: this.filterMatchingOptions(
          this.states,
          this.profileByManagement.state
        ),
        onlyCanada: this.filterMatchingOptions(
          this.provinces,
          this.profileByManagement.state
        ),
        defaultValue: [],
      });
    } else {
      this.state.push({
        id: this.profileByManagement.state,
        name: this.profileByManagement.state,
      });
    }
  }

  get primaryCountry(): boolean {
    const countryNames = this.country.map((country) => country.name);
    return isAllStatesOfPrimaryCountry(countryNames);
  }

  filterMatchingOptions(options: DropdownOption[], searchString: string) {
    return options.filter((option) =>
      this.hasSearchValue(option.name, searchString)
    );
  }

  hasSearchValue(optionName: string, searchString: string) {
    return optionName.toLowerCase().includes(searchString.toLowerCase());
  }

  states: DropdownOption[] = (
    Object.keys(States) as Array<keyof typeof States>
  ).map((key) => {
    return {
      id: States[key],
      name: States[key],
    };
  });

  provinces: DropdownOption[] = (
    Object.keys(Provinces) as Array<keyof typeof Provinces>
  ).map((key) => {
    return {
      id: Provinces[key],
      name: Provinces[key],
    };
  });

  async getSkills(): Promise<void> {
    this.loading = true;
    let query = await this.$apollo.query({
      query: GET_SKILLS_BY_MANAGEMENT,
      variables: {
        userId: this.userId,
        added_by_id: this.currentUser.id,
      },
      fetchPolicy: "no-cache",
    });
    this.skills = query?.data?.user_skill;
    if (this.skills) {
      this.skillsIds = this.skills.map((skill) => {
        return skill.skill.id;
      });
    }
    this.loading = false;
  }

  async upsertSkills(): Promise<void> {
    this.processing = true;
    await this.$apollo.mutate({
      mutation: UPSER_SKILLS_BY_MANAGEMENT,
      variables: {
        userId: this.userId,
        added_by_id: this.currentUser.id,
        skillsSet: this.userSkills,
      },
    });
    this.processing = false;
    this.closeModalAndRefreshContractor();
  }

  async getIndustries(): Promise<void> {
    this.loading = true;
    let query = await this.$apollo.query({
      query: GET_INDUSTRIES_BY_MANAGEMENT,
      variables: {
        userId: this.userId,
        added_by_id: this.currentUser.id,
      },
      fetchPolicy: "no-cache",
    });
    this.industries = query?.data?.user_industry.map(
      (industry: User_Industry) => industry.industry
    );
    this.loading = false;
  }

  async upsertIndustries(): Promise<void> {
    this.processing = true;
    await this.$apollo.mutate({
      mutation: UPSER_INDUSTRIES_BY_MANAGEMENT,
      variables: {
        userId: this.userId,
        added_by_id: this.currentUser.id,
        industriesSet: this.userIndustries,
      },
    });
    this.processing = false;
    this.closeModalAndRefreshContractor();
  }

  async getLanguages(): Promise<void> {
    this.loading = true;
    let query = await this.$apollo.query({
      query: GET_LANGUAGES_BY_MANAGEMENT,
      variables: {
        userId: this.userId,
        added_by_id: this.currentUser.id,
      },
      fetchPolicy: "no-cache",
    });
    this.languages = query?.data?.user_language.map(
      (language: User_Language) => language.language
    );
    this.loading = false;
  }

  async upsertLanguages(): Promise<void> {
    this.processing = true;
    await this.$apollo.mutate({
      mutation: UPSER_LANGUAGES_BY_MANAGEMENT,
      variables: {
        userId: this.userId,
        added_by_id: this.currentUser.id,
        languagesSet: this.userLanguages,
      },
    });
    this.processing = false;
    this.closeModalAndRefreshContractor();
  }

  async upsertDemoReels(): Promise<void> {
    this.processing = true;
    await this.$apollo.mutate({
      mutation: UPSER_DEMOREELS_BY_MANAGEMENT,
      variables: {
        userId: this.userId,
        added_by_id: this.currentUser.id,
        demoReel: this.demo_reel,
      },
    });
    this.processing = false;
    this.closeModalAndRefreshContractor();
  }

  async removeDemoReels(): Promise<void> {
    this.processing = true;
    await this.$apollo.mutate({
      mutation: REMOVE_DEMOREELS_BY_MANAGEMENT,
      variables: {
        userId: this.userId,
        addedBy: this.currentUser.id,
      },
    });
    this.processing = false;
    this.closeModalAndRefreshContractor();
  }
  async upsertProfileByManagement(): Promise<void> {
    this.processing = true;
    let profileByManagementSet: Partial<User_Profile_By_Management> = {
      user_id: this.userId,
      added_by_id: this.currentUser.id,
      email: this.email,
      phone: this.phone,
      about: this.about,
      city: this.city,
      company_name: this.company_name,
      created_at: this.created_at ? new Date(this.created_at) : new Date(),
      currency: this.currency,
      demo_reel: this.demo_reel,
      job_title: this.job_title,
      max_rate: this.max_rate ? this.max_rate : null,
      min_rate: this.min_rate ? this.min_rate : null,
      occupation: this.occupation,
      postal_code: this.postal_code,
      rate_unit: this.rate_unit,
      resume: this.resume,
      summary: this.summary,
      updated_at: this.updated_at ? new Date(this.updated_at) : new Date(),
      website: this.website,
      work_samples: !!this.work_samples
        ? !!this.work_samples.length
          ? this.work_samples
          : undefined
        : undefined,
      year_of_experience: this.year_of_experience,
      country: this.countryName,
      state: this.state[0]?.name || "",
    };
    await this.$apollo.mutate({
      mutation: UPSERT_PROFILE_BY_MANAGEMENT,
      variables: {
        userId: this.userId,
        added_by_id: this.currentUser.id,
        profileByManagementSet: profileByManagementSet,
      },
    });
    this.processing = false;
    this.$emit("refetchProfileByManagement");
    this.closeModal();
  }

  @Watch("countryName", { immediate: false })
  clearCountry(newCountry: string): void {
    if (newCountry !== this.countryFromDB || !Boolean(newCountry)) {
      this.state = [];
      this.city = "";
      this.postal_code = "";
    }
  }

  get countryName(): string {
    return this.country[0]?.name || "";
  }

  get userIndustries(): Partial<User_Industry>[] {
    return this.industries.map(({ id }) => ({
      user_id: this.userId,
      industry_id: id,
      added_by_id: this.currentUser.id,
    }));
  }

  get userSkills(): Partial<User_Skill>[] {
    return this.skillsIds.map((skillId) => ({
      user_id: this.userId,
      skill_id: skillId,
      added_by_id: this.currentUser.id,
    }));
  }

  get userLanguages(): Partial<User_Language>[] {
    return this.languages.map(({ id }) => ({
      user_id: this.userId,
      language_id: id,
      added_by_id: this.currentUser.id,
    }));
  }

  get stateValidationRules(): string | undefined {
    return getStateValidationRules(this.countryName);
  }

  intercomNewMessage(): void {
    // @ts-ignore
    Intercom("showNewMessage", "Skills to add: ");
  }

  closeModalAndRefreshContractor(): void {
    this.$emit("refreshContractor");
    this.closeModal();
  }
}
